import { graphql } from 'gatsby';
import { Heading } from 'lucid-components-react';
import React from 'react';

import LucidContainer from 'components/lucid-container/lucid-container';
import NineteenCta from 'components/nineteen/nineteen-cta/nineteen-cta';
import {
  Drupal_FieldParagraphNineteenHeroFieldNineteenCtas,
  Drupal_ParagraphNineteenHero
} from 'generated/graphql';
import { Text } from 'theme/typography';
import { LucidTheme } from 'types/types';

interface Props {
  entity: Drupal_ParagraphNineteenHero;
}

const NineteenHero = ({
  entity: { fieldHeader, fieldSubheader, fieldNineteenCtas }
}: Props) => (
    /* eslint-disable-next-line react/jsx-indent */
    <header
      className="nineteen-hero"
      css={theme => ({
        padding: `${theme.space[7]}px 0`,
        [`@media screen and (min-width: ${theme.breakpoints.tablet})`]: {
          padding: `${theme.space[9]}px 0 ${theme.space[8]}px`
        }
      })}
    >
      <LucidContainer>
        <Heading
          css={{
            maxWidth: '45rem'
          }}
        >
          {fieldHeader}
        </Heading>
        <Text
          css={(theme: LucidTheme) => ({
            fontWeight: theme.fontWeights.body
          })}
          textStyles="subhead"
        >
          {fieldSubheader}
        </Text>
        {(fieldNineteenCtas as Drupal_FieldParagraphNineteenHeroFieldNineteenCtas[]).map(
          ({ entity }, index) => (
            <NineteenCta
              key={entity!.entityId}
              entity={entity!}
              primary={index === 0}
            />
          )
        )}
      </LucidContainer>
    </header>
  );

export default NineteenHero;

export const query = graphql`
  fragment nineteenHero on Drupal_ParagraphNineteenHero {
    fieldHeader
    fieldSubheader
    fieldNineteenCtas {
      entity {
        ...nineteenCta
      }
    }
  }
`;
